import styled from 'styled-components';

const Wrapper = styled.div`
  min-height: 196px;
`;

export default {
  Wrapper,
};
